module.exports = __webpack_public_path__ + "static/img/new-logo-contact-qr.effde1dc.png";